export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl mb-10`}>
      {eyebrow && (
        <p className="text-[11px] uppercase tracking-[0.28em] text-[#0EA5E9] font-medium mb-3">{eyebrow}</p>
      )}
      <h2 className="font-display text-4xl md:text-5xl text-[#0B132B] tracking-tight leading-tight">{title}</h2>
      {subtitle && <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">{subtitle}</p>}
    </div>
  );
}
